import { render } from "./NotificationsUser.vue?vue&type=template&id=5fc42629"
import script from "./NotificationsUser.vue?vue&type=script&lang=js"
export * from "./NotificationsUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__